<template>
  <b-card
    header="ECART STOCK"
    header-bg-variant="dark"
    border-variant="dark"
    header-text-variant="white"
    align="center">
    <b-card-text @click="goTo('/andon/'+item.andon.kanban_id)">
      <b>{{displayRef(item.andon.kanban_id)}}</b>
      <br />
      {{item.andon.kanban_reference.reference.supermarket_emplacement}}
      <b-badge pill variant="danger" v-if="item.andon.base.severity == 'high'">CRITIQUE</b-badge><br/>
      <br />
      Kanban<br/><b-badge variant="info">{{item.andon.kanban_stock}}</b-badge>
      <br />
      ERP<br/> <b-badge variant="info">{{item.andon.erp_stock}}</b-badge>
      <br />
      <br/>
      <b-badge variant="danger"> >{{item.andon.threshold}} % <i class="fa fa-arrows-h" aria-hidden="true"></i></b-badge>
    </b-card-text>
    <b-button v-if="isUserAdmin()" size="sm" variant="danger" @click="stopCardAndon()"><i class="fa fa-trash" aria-hidden="true"></i></b-button>
    <b-button v-if="isUserAdmin()" size="sm" variant="danger" @click="deleteRef()">SUPER DELETE <i class="fa fa-trash" aria-hidden="true"></i></b-button>
  </b-card>
</template>
<script>

import server from '../../api/server.vue'


export default {
  name: 'BadErpStockCard',
  props: ['item'],
  data() {
    return {
    };
  },
  methods: {
    stopCardAndon () {
      server.stopSpecificAndon(this.item.andon.base_id).then(() => {
        this.$emit('andon-stopped')
      })
    },
    getIsAdmin() {
      return window.localStorage.getItem('isAdmin') === 'ADMIN'
    },
    displayRef(reference) {
      return this.chunk(reference, 3)
    },
    deleteRef () {
      server.deleteReferenceFromAndonKanban(this.item.andon.kanban_reference.reference.code).then(() => {
        server.stopSpecificAndon(this.item.andon.base_id).then(() => {
            this.$emit('andon-stopped')
        })
      })
    }
  },
  mounted: function() {
    console.log(this.item)
  }
};
</script>

<style scoped>
  .card {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/andon/BadErpStockCard.vue